var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterTreatmentPlantCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.68C3 10.3044 3.32236 10 3.72 10H20.28C20.6776 10 21 10.3044 21 10.68V22.4516C21 22.6418 20.9157 22.8233 20.7675 22.952L12.4875 30.1464C12.2119 30.3859 11.7881 30.3859 11.5125 30.1464L3.23252 22.952C3.08433 22.8233 3 22.6418 3 22.4516V10.68Z",
    stroke: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63013 18.3304C3.63013 17.9548 3.95248 17.6504 4.35013 17.6504H19.5601C19.9578 17.6504 20.2801 17.9548 20.2801 18.3304V22.1152C20.2801 22.3035 20.1975 22.4834 20.0518 22.612L12.4892 29.2887C12.2135 29.532 11.7857 29.5331 11.5086 29.2911L3.86129 22.6123C3.71392 22.4836 3.63013 22.3026 3.63013 22.113V18.3304Z",
    fill: "#2486FD",
    fillOpacity: 0.2,
    stroke: "#1070CA",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 9,
    r: 6,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7811 1.5H18.2447C18.028 1.5 17.8112 1.59167 17.6611 1.74167L13.7506 5.65C13.6005 5.8 13.5088 6.01667 13.5088 6.23333V11.7583C13.5088 11.9833 13.6005 12.1917 13.7506 12.35L17.6527 16.25C17.8112 16.4083 18.028 16.5 18.2447 16.5H23.7728C23.9979 16.5 24.2064 16.4083 24.3648 16.2583L28.2669 12.3583C28.3446 12.2807 28.406 12.1884 28.4475 12.0869C28.489 11.9853 28.5098 11.8764 28.5087 11.7667V6.23333C28.5087 6.00833 28.417 5.8 28.2669 5.64167L24.3648 1.74167C24.2147 1.59167 23.9979 1.5 23.7811 1.5ZM21.0129 13.4167C20.4126 13.4167 19.929 12.9333 19.929 12.3333C19.929 11.7333 20.4126 11.25 21.0129 11.25C21.6133 11.25 22.0969 11.7333 22.0969 12.3333C22.0969 12.9333 21.6133 13.4167 21.0129 13.4167ZM21.0129 9.83333C20.5544 9.83333 20.1791 9.45833 20.1791 9V5.66667C20.1791 5.20833 20.5544 4.83333 21.0129 4.83333C21.4715 4.83333 21.8467 5.20833 21.8467 5.66667V9C21.8467 9.45833 21.4715 9.83333 21.0129 9.83333Z",
    fill: "#FF4842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterTreatmentPlantCritical);
export default __webpack_public_path__ + "static/media/water_treatment_plant_critical.5f40dcd6a909f719a7bac9376e5f9ea9.svg";
export { ForwardRef as ReactComponent };